// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill2","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M22 13.9961H15.5V21.5L18.7535 19.5L22 21.5V13.9961Z","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"system-marked"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M22 13.9961H15.5V21.5L18.7535 19.5L22 21.5V13.9961Z","mask":"props.overlapMaskUrl_fill2"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 10V3H2V17H11.5M4 21H11.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22 13.9961H15.5V21.5L18.7535 19.5L22 21.5V13.9961Z","strokeWidth":"props.strokeWidth"}}]}]};

const SystemMarkedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-marked',
    ref,
    icon: element,
  },
));

SystemMarkedIcon.displayName = 'SystemMarkedIcon';

export default SystemMarkedIcon;
